import React from 'react'
import clsx from 'clsx'
import { FormControlLabel, Switch as MUISwitch } from '@material-ui/core'
import useStyles from './FormFieldsStyle'

export default function Switch({ field, values, setValues, errors }) {
  const classes = useStyles()

  return (
    <FormControlLabel
      className={clsx(classes.withMargin, classes.switch)}
      control={
        <MUISwitch
          checked={values[field.key]}
          onChange={() => {
            delete errors[field.key]
            setValues({ ...values, [field.key]: !values[field.key] })
            if (field.onChange) {
              field.onChange()
            }
          }}
          name={field.key}
          color="primary"
          classes={{
            switchBase: classes.switchBase,
            checked: classes.checked,
            track: classes.track,
          }}
        />
      }
      label={field.label}
      classes={{ label: classes.switchLabel }}
    />
  )
}
